import { isNullish } from '@y42/util/nullish';
import * as go from 'gojs';
import * as _ from 'lodash/fp';

// this is needed for the goJS to update node templates if they are initiated after the elements are loaded into diagram
export const updateNodesCategories = (diagram: go.Diagram, categories: string[]) => {
  if (isNullish(diagram?.model?.nodeDataArray)) {
    return;
  }

  const categoryObj = _.keyBy((x) => x)(categories);
  const tmpCategoryName = 'tmpCat';

  diagram.model.nodeDataArray
    .filter((n) => n.category in categoryObj)
    .forEach((n) => {
      const tmp = n.category;
      diagram.model.setCategoryForNodeData(n, tmpCategoryName);
      diagram.model.setCategoryForNodeData(n, tmp);
    });
};
